import {
  CompartmentUserAssignmentURIParams,
  CompartmentUserDeassignmentURIParams,
  CompartmentUserListURIParams,
  CompartmentUserUpdateUserPermissionsURIParams,
} from '../../models';

export class CompartmentAssignedUserListLoad {
  public static readonly type = '[CompartmentUserList] Assigned Load';

  constructor(public payload: CompartmentUserListURIParams) {}
}

export class CompartmentAvailableUserListLoad {
  public static readonly type = '[CompartmentUserList] Available Load';

  constructor(public payload: CompartmentUserListURIParams) {}
}

export class CompartmentUserListAssignUsers {
  public static readonly type = '[CompartmentUserList] Assign Users';

  constructor(public payload: CompartmentUserAssignmentURIParams) {}
}

export class CompartmentUserListDeassignUsers {
  public static readonly type = '[CompartmentUserList] Deassign Users';

  constructor(public payload: CompartmentUserDeassignmentURIParams) {}
}

export class CompartmentUserListResetAvailableList {
  public static readonly type = '[CompartmentUserList] Reset Available List';
}

export class CompartmentUserListUpdateUserPermissions {
  public static readonly type = '[CompartmentUserList] Update User Permissions';

  constructor(public payload: CompartmentUserUpdateUserPermissionsURIParams) {}
}

export class CompartmentUserListInitialState {
  public static readonly type = '[CompartmentUserList] Set initial state';
}
